import { render } from "./Attached.vue?vue&type=template&id=3d734e10"
import script from "./Attached.vue?vue&type=script&lang=js"
export * from "./Attached.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Project\\远创人力\\开发\\前端\\yc_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__